import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(amount: number, currency = 'USD') {
  if (Number.isNaN(amount)) return '—'

  try {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
    }).format(amount)
  } catch (error) {
    console.warn('[formatCurrency] Failed to format', { amount, currency, error })
    return `${currency} ${amount.toFixed(2)}`
  }
}

export function getFirstName(displayName?: string, firstName?: string): string {
  const normalizedFirstName = firstName?.trim()
  if (normalizedFirstName) return normalizedFirstName

  const normalizedDisplayName = displayName?.trim()
  if (!normalizedDisplayName) return 'there'

  const [firstToken] = normalizedDisplayName.split(/\s+/)
  return firstToken || 'there'
}
